import React, { useState, useRef, useEffect } from "react";
import styles from "./contact-item.module.css";
import { MyIcons } from "../../icons/my-icons";

const ContactItem = ({ contact, onRemove, onClick, onCall, onEdit, hideActions = false }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);
  
  // Si hideActions es true o no hay acciones disponibles, no mostrar menú
  const hasActions = !hideActions && (onRemove || onEdit || onCall);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuOpen]);

  const handleMenuToggle = (e) => {
    e.stopPropagation();
    setIsMenuOpen(!isMenuOpen);
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    setIsMenuOpen(false);
    if (onEdit) {
      onEdit(contact);
    }
  };

  const handleCall = (e) => {
    e.stopPropagation();
    setIsMenuOpen(false);
    if (onCall) {
      onCall(contact);
    }
  };

  const handleRemove = (e) => {
    e.stopPropagation();
    setIsMenuOpen(false);
    if (onRemove) {
      onRemove(contact.id);
    }
  };

  return (
    <div 
      className={`${styles.contactItem} ${onClick ? styles.clickable : ''}`}
      onClick={onClick ? () => onClick(contact) : undefined}
    >
      <div className={styles.contactInfo}>
        <div className={styles.contactName}>{contact.name}</div>
        <div className={styles.contactDetails}>
          {contact.phone && (
            <span className={styles.contactSecondary}>
              {contact.phone + " - "}
            </span>
          )}
          <span className={styles.contactSecondary}>
            {contact.address}
          </span>
        </div>
        {contact.rol && (
          <p className={styles.contactSecondary}>
            {contact.rol.label}
          </p>
        )}
        {contact.info && (
          <p className={styles.contactAdditional}>
            {contact.info}
          </p>
        )}
      </div>
      
      {hasActions && (
        <div className={styles.actionsContainer} ref={menuRef}>
          <button
            type="button"
            className={styles.menuButton}
            onClick={handleMenuToggle}
          >
            <MyIcons name="threeDots" width={20} height={20} color="var(--dark-grey)" />
          </button>

          {isMenuOpen && (
            <div className={styles.menuDropdown}>
              {onEdit && (
                <button
                  type="button"
                  className={styles.menuItem}
                  onClick={handleEdit}
                >
                  <MyIcons name="settings" width={16} height={16} color="var(--black)" />
                  <span>Editar</span>
                </button>
              )}
              {contact.phone && onCall && (
                <button
                  type="button"
                  className={styles.menuItem}
                  onClick={handleCall}
                >
                  <MyIcons name="phone" width={16} height={16} color="var(--green)" />
                  <span>Llamar</span>
                </button>
              )}
              {onRemove && (
                <button
                  type="button"
                  className={styles.menuItem}
                  onClick={handleRemove}
                >
                  <MyIcons name="close" width={16} height={16} color="var(--red)" />
                  <span>Eliminar</span>
                </button>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ContactItem;